import { render, staticRenderFns } from "@/modules/CaseReports/templates/reports.html?vue&type=template&id=5b19b65a&scoped=true&"
import script from "@/modules/CaseReports/scripts/reports.ts?vue&type=script&lang=js&"
export * from "@/modules/CaseReports/scripts/reports.ts?vue&type=script&lang=js&"
import style0 from "@/modules/CaseReports/styles/reports.scss?vue&type=style&index=0&id=5b19b65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19b65a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
